import Button from '@jetbrains/ring-ui/components/button/button'
import Dialog from '@jetbrains/ring-ui/components/dialog/dialog'
import {H1} from '@jetbrains/ring-ui/components/heading/heading'
import * as React from 'react'

import styles from './DialogTrigger.css'

type Props = {
  title: string
  triggerTitle: string
  className?: string | undefined
  children: React.ReactNode
  show: boolean
  disabled?: boolean
  onShow: () => void
  onHide: () => void
}

function DialogTrigger({
  className,
  title,
  triggerTitle,
  children,
  show,
  disabled,
  onShow,
  onHide,
}: Props): React.ReactElement {
  return (
    <>
      <Button onClick={onShow} className={className} disabled={disabled}>
        {triggerTitle}
      </Button>
      <Dialog
        show={show}
        onCloseAttempt={onHide}
        className={styles.dialog}
        contentClassName={styles.dialogContent}
      >
        <H1 className={styles.header}>{title}</H1>
        {children}
      </Dialog>
    </>
  )
}

export default React.memo(DialogTrigger)
